const finished_questionnaires = {
  'finished_questionnaires_title': "You finished answering all the current questionnaires",
  'finished_questionnaires_button': "Home",
  'finished_questionnaire_title': "You reached the end of the questionnaire",
}


export default finished_questionnaires;
